import { CeiBreadcrumbItem, CeiBreadcrumbsConfig } from '@cei-ufg/ngx-arquitetura-cei-frontend';

const ROTULOS_LISTA_ADMIN: Record<string, string> = {
  '/admin/pessoas': 'Pessoas',
  '/admin/grupos': 'Grupos',
  '/admin/permissoes': 'Permissões',
  '/admin/aplicacoes': 'Aplicações',
  '/admin/entidades': 'Entidades',
  '/admin/recursos': 'Recursos',
};

const ROTULOS_DETALHE_ADMIN: Record<string, string> = {
  '/admin/pessoas': 'Detalhes da pessoa / usuário',
  '/admin/grupos': 'Detalhes do Grupo',
  '/admin/permissoes': 'Detalhes da Permissão',
  '/admin/recursos': 'Detalhes do Recurso',
  '/admin/usuarios': 'Detalhes do Usuário',
};

function normalizarCaminhoRota(rota: string | readonly unknown[] | null | undefined): string | null {
  if (rota == null) {
    return null;
  }

  if (typeof rota === 'string') {
    return rota.split('?')[0].split('#')[0];
  }

  if (Array.isArray(rota) && typeof rota[0] === 'string') {
    return rota[0];
  }

  return null;
}

function caminhosIguais(
  a: string | readonly unknown[] | null | undefined,
  b: string | readonly unknown[] | null | undefined,
): boolean {
  const caminhoA = normalizarCaminhoRota(a);
  const caminhoB = normalizarCaminhoRota(b);
  return !!caminhoA && caminhoA === caminhoB;
}

export function rotuloListaAdmin(
  rotaLista: string | readonly unknown[] | null | undefined,
  rotuloLista?: string | null,
): string | null {
  if (rotuloLista?.trim()) {
    return rotuloLista.trim();
  }

  const caminho = normalizarCaminhoRota(rotaLista);
  if (!caminho) {
    return null;
  }

  return ROTULOS_LISTA_ADMIN[caminho] ?? null;
}

export function rotuloDetalheAdmin(
  rotaLista: string | readonly unknown[] | null | undefined,
  rotuloDetalhe?: string | null,
): string {
  if (rotuloDetalhe?.trim()) {
    return rotuloDetalhe.trim();
  }

  const caminho = normalizarCaminhoRota(rotaLista);
  if (caminho && ROTULOS_DETALHE_ADMIN[caminho]) {
    return ROTULOS_DETALHE_ADMIN[caminho];
  }

  return 'Detalhes';
}

/** Lista (+ detalhe, se `rotaDetalhe` for distinta) + página atual. */
export function montarTrilhaAdmin(
  titulo: string,
  rotaLista: string | readonly unknown[] | null | undefined,
  trilha?: CeiBreadcrumbsConfig | null,
  rotuloLista?: string | null,
  rotaDetalhe?: string | readonly unknown[] | null,
  rotuloDetalhe?: string | null,
): CeiBreadcrumbsConfig | null {
  if (trilha?.level1) {
    return trilha;
  }

  const plainItems: CeiBreadcrumbItem[] = [];
  const caminhoLista = normalizarCaminhoRota(rotaLista);
  const rotulo = rotuloListaAdmin(rotaLista, rotuloLista);

  if (caminhoLista && rotulo) {
    plainItems.push({ label: rotulo, routerLink: rotaLista ?? caminhoLista });
  }

  if (rotaDetalhe && !caminhosIguais(rotaLista, rotaDetalhe)) {
    plainItems.push({
      label: rotuloDetalheAdmin(rotaLista, rotuloDetalhe),
      routerLink: rotaDetalhe,
    });
  }

  return {
    plainItems,
    level1: { label: titulo },
  };
}
